import { COMPONENTS } from '../../../components/components.registry';
import { PopularSearchesConfig } from '../../../models';

export const DEFAULT_POPULAR_SEARCHES_CONFIG: PopularSearchesConfig = {
  components: {
    container: COMPONENTS.PURE.Suggestions,
    item: COMPONENTS.PURE.TermSuggestion,
    header: null,
    icon: null
  },
  size: 10,
  showSameQuerySuggestion: false,
  showExtraSuggestionWithoutFacet: true,
  siftWithHistoryQueries: true,
  requestSize: 40
};
